import { Box, CircularProgress } from '@mui/material';

export default function Loading() {
    return (
        <Box textAlign="center" marginX="auto" marginY={2}>
            <CircularProgress />
        </Box>
    );
}
